import React, { useEffect, useState } from "react";
import { publicHolidays } from "../data/publicHolidays";
import { useAuth } from "../context/AuthProvider";
import { Card } from "react-bootstrap";

export default function Holidays() {
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();
  const holidays = publicHolidays.filter(h => h.date.startsWith(currentYear.toString()));

  // Group holidays by month
  const holidaysByMonth = holidays.reduce((acc, h) => {
    const month = new Date(h.date).toLocaleString("default", { month: "long" });
    if (!acc[month]) acc[month] = [];
    acc[month].push(h);
    return acc;
  }, {});

  return (
    <div className="container py-4">
      <h2 className="mb-4">Public Holidays - {currentYear}</h2>
      {Object.keys(holidaysByMonth).length === 0 ? (
        <div>No holidays found for this year.</div>
      ) : (
        Object.entries(holidaysByMonth).map(([month, hols]) => (
          <Card className="mb-3" key={month}>
            <Card.Header><b>{month}</b></Card.Header>
            <Card.Body>
              <ul>
                {hols.map(h => (
                  <li key={h.date}><b>{h.date}</b>: {h.name}</li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        ))
      )}
    </div>
  );
}
